module.exports = __webpack_public_path__ + "img/bg_pink_2600x588.68ab640.png";